$ = jQuery;
export const parallax = {
  imgPattern: document.getElementById("img-pattern"),
  imgFlower: document.getElementById("img-flower"),
  imgEcosysteme: document.getElementById("ecosysteme"),
  init: function () {
    this.imgPattern.style.setProperty("--imgPatternTop", "0px");
    this.imgFlower.style.setProperty("--imgTop", "0px");
    this.imgFlower.style.setProperty("--imgBottom", "0px");
    this.imgEcosysteme.style.setProperty("--imgTtTop", "0px");
    this.background_image_parallax(this.imgPattern, 0.2);
    this.background_image_parallax(this.imgFlower, 0.1);
    this.background_image_parallax(this.imgEcosysteme, 0.15);
  },
  background_image_parallax: function (object, multiplier) {
    var $doc = $(document);
    $(window).scroll(function () {
      var from_top = $doc.scrollTop(),
        bg_css = multiplier * from_top + "px";
      object.style.setProperty("--imgPatternTop", bg_css);
      object.style.setProperty("--imgTop", bg_css);
      object.style.setProperty("--imgBottom", bg_css);
      object.style.setProperty("--imgTtTop", bg_css);
    });
  },
};
